module.exports = __webpack_public_path__ + "static/media/DT-top-full.5b15811a.png";